/**
 * Перезагрузка страницы, которую запускает само приложение после успешного
 * сохранения (например, смена организации). FormBuilder с
 * warnOnUnsavedChanges к этому моменту ещё считает форму изменённой: ответ
 * мутации пришёл раньше, чем форма приняла новые значения. Без флага браузер
 * спрашивал бы «Changes you made may not be saved», хотя всё сохранено.
 */
let unloadAllowed = false;

export function isUnloadPromptSuppressed(): boolean {
  return unloadAllowed;
}

export function reloadWithoutPrompt(
  reload: () => void = () => window.location.reload()
): void {
  unloadAllowed = true;
  reload();
}

/** Для тестов: вернуть флаг в исходное состояние. */
export function resetUnloadPromptSuppression(): void {
  unloadAllowed = false;
}
